<template>
  <div class="zl-detail">
      <div class="back-btn">
          <el-button size="small" @click="back">{{$t('zlfk.backto')}}</el-button>
      </div>
      <el-divider content-position="center">{{$t('zlfk.detail')}}</el-divider>
      <div class="basic">
          <div class="d-title">{{$t('zlfk.basic')}}</div>
          <el-form :disabled="true" label-position="left" :model="feedbackInfo"  label-width="100px" class="demo-dynamic">
              <el-form-item
                  prop="theme"
                  :label="$t('zlfk.theme')"
                 
              >
                  <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 6}"  :disabled="true" v-model="feedbackInfo.informationSubject"></el-input>
              </el-form-item>
              <el-form-item

                  :label="$t('zlfk.vin')"

                  prop="vin"
                  
              >
                  <el-input v-model="feedbackInfo.vin"></el-input>
              </el-form-item>
             
          </el-form>
          
      </div>
      <el-divider content-position="center">{{$t('zlfk.process')}}</el-divider>
      <div class="flex" v-show="!showProgress">
          <el-skeleton :rows="6" animated style="width: 30%;"/>
          <!-- <el-skeleton :rows="6" animated style="width: 30%;margin-left:30px;"/> -->
      </div>
      <div class="result-box" v-show="showProgress">
          <div class="process flex" v-show="feedbackInfo.displayStatus!=4">
              <div class="p-content flex">
                 <p class="status-txt">{{$t('zlfk.apply')}}</p> 
              </div>
              <div class="prcs-item flex" v-show="feedbackInfo.displayStatus>=0">
                  <div class="p-line"><img src="../../assets/img/line.png" alt=""></div>
                  <div class="p-content flex">
                     <p class="status-txt ">{{$t('zlfk.sp')}}</p> 
                  </div>
              </div>
              <div class="prcs-item flex" v-show="detail.displayStatus>=1">
                  <div class="p-line"><img src="../../assets/img/line.png" alt=""></div>
                  <div class="p-content flex">
                      <div>
                          <p class="status-txt ">{{$t('zlfk.dcl')}}</p>
                          <div v-show="detail.pass==1" class="p-line" ><img style="height:70px;" src="../../assets/img/line.png" alt=""></div>
                      </div>

                     <div class="way flex">
                      <span>{{$t('zlfk.temporary')}}：</span>
                      <div class="text">
                          <p v-show="temporary.auditText!=''">{{temporary.auditText}}</p>
                          <div style="margin-top: 10px;" v-show="detail.displayStatus==1">
                              <el-button :disabled="isSubmit" type="primary" size="small" @click="handlePass(0)">{{$t('zlfk.ty')}}</el-button>
                              <el-button  :disabled="isSubmit"  plain size="small" @click="notPassDialog = true">{{$t('zlfk.bty')}}</el-button>
                          </div>
                      </div>
                      <div class="flex img-content">
                          <div class="img-box flex" v-show="temporary.picList.length>0"  v-for="(item,i) in temporary.picList" :key="i">
                          
                              <img :src="item.filePath" alt="">
                              <div class="zzc">
                                  <i @click="handleBigImg(item.filePath)" class="el-icon-zoom-in"></i>
                              </div>
                          
                          
                      </div>
                      </div>

                     </div>
                  </div>
              </div>
              <div class="prcs-item flex"  v-show="detail.pass==0">
                  <div class="p-line"><img src="../../assets/img/line.png" alt=""></div>
                  <div class="p-content flex">
                     <p class="status-txt " :class="detail.displayStatus==1?'active':''">{{$t('zlfk.manage')}}</p> 
                  </div>
              </div>
              <div class="prcs-item flex"  v-show="detail.displayStatus>1&&detail.waybillInfo">
                  <div class="p-line"><img src="../../assets/img/line.png" alt=""></div>
                  <div class="p-content flex">
                     <p class="status-txt " :class="detail.displayStatus==1?'active':''">{{$t('zlfk.confirmBack')}}</p> 
                     <div class="way flex">
                      <el-button type="primary" @click="toBack" size="small">{{$t('zlfk.lookBack')}}</el-button>
                     </div>
                  </div>
              </div>
              <div class="prcs-item flex"  v-show="detail.displayStatus>1">
                  <div class="p-line"><img src="../../assets/img/line.png" alt=""></div>
                  <div class="p-content flex">
                     <p class="status-txt " :class="detail.displayStatus==2?'active':''">{{$t('zlfk.clz')}}</p> 
                  </div>
              </div>
              <div class="prcs-item flex" v-show="detail.displayStatus>1&&detail.permanentSolution!==null">
                  <div class="p-line"><img src="../../assets/img/line.png" alt=""></div>
                  <div class="p-content flex">
                     <p class="status-txt ">{{$t('zlfk.clok')}}</p> 
                     <div class="way flex">
                      <span>{{$t('zlfk.foeverWay')}}：</span>
                      <div  class="text">
                          <p>{{permanentSolution.auditText}}</p>

                      </div>
                      <div class="flex  img-content" v-show="permanentSolution.picList.length>0">
                          <div class="img-box flex" v-for="(item,i) in permanentSolution.picList" :key="i">
                          
                              <img :src="item.filePath" alt="">
                              <div class="zzc">
                                  <i @click="handleBigImg(item.filePath)" class="el-icon-zoom-in"></i>
                              </div>
                          
                          
                      </div>
                      </div>

                     </div>
                  </div>
              </div>
          </div>
          
          <div class="reject-box" v-show="feedbackInfo.displayStatus==4">
          <p class="reject-title">{{ $t('climant.rejected') }} <i class="retime" >{{ feedbackInfo.rejectTime }}</i></p>
          <div class="text flex_center"><span>{{ $t('zlfk.bhyy') }}: </span>
            <p v-if="feedbackInfo.rejectReasonTranslate.length==0">{{feedbackInfo.rejectReasonChinese}}</p>
            <p v-else>{{feedbackInfo.rejectReasonTranslate}}</p>
            
          </div>
          
          </div>
      </div>
      
      <el-dialog
          :close-on-click-modal="false"
        :title="$t('zlfk.notReason')+'：'"
        :visible.sync="notPassDialog"
        width="30%"
        center>
        <div>
          <el-input
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 6}"
          :placeholder="$t('zlfk.pleaseReason')"
          v-model="textarea">
          </el-input>
          <el-upload
          :disabled="uploading"
            class="upload-demo"
            :on-success="handleSuccessFile"
               ref="uploadFile"
              :data="fileData"
              :before-upload="beforeFileUpload"
            :action="action"
            :on-remove="handleRemove"
            :on-change="handleChange"
            multiple
           
           >
            <el-button type="text" icon="el-icon-paperclip" size="small" >{{$t('zlfk.upload')}}</el-button>
            
          </el-upload>
        </div>
        <span slot="footer" class="dialog-footer">
          
          <el-button type="primary" :disabled="uploading&&!isSubmit"  @click="handlePass(1)">{{$t('zlfk.ok')}}</el-button>
          <el-button  @click="notPassDialog = false">{{$t('zlfk.backto')}}</el-button>
        </span>
      </el-dialog>
      <el-dialog
          :close-on-click-modal="false"
        :title="$t('zlfk.foeverWay')"
        :visible.sync="lastDialog"
        width="520px"
        center>
        <div  class="text">
              <p style="margin-bottom: 20px;max-width: 480px;">{{permanentSolution.auditText}}</p>
              <span  v-show="permanentSolution.picList.length>0">{{$t('zlfk.fj')}}</span>
            <div class="flex  img-content2" v-show="permanentSolution.picList.length>0">
              <div class="img-box flex" v-for="(item,i) in permanentSolution.picList" :key="i">
                  <div class="img" >
                      <img :src="item.filePath" alt="">
                      <div class="zzc">
                          <i @click="handleBigImg(item.filePath)" class="el-icon-zoom-in"></i>
                      </div>
                  </div>
                  
              </div>
           </div>   
          </div>
        <span slot="footer" class="dialog-footer">
          
          <el-button type="primary" :disabled="isSubmit" @click="handleFinished">{{$t('zlfk.read')}}</el-button>
        </span>
      </el-dialog>
      <el-dialog title="" :visible.sync="dialogBig" width="500px" center>
          <div class="big-img"><img :src="bigImg" ></div>
      </el-dialog>
  </div>
</template>
<script>
import { baseURL2 } from '@/util/url'
import { getStorage,setSession,getSession } from '@/util/localStor'
import { isPass,feedBackDetail,knowWaybill } from '@/api/feedback'

export default {
  data() {
    return {
      fileList:[],
      max:500,
      sum:0,
      uploading:false,
      upLoadFiles:[],
      fileData:{
          fileType:17,
          customerId:'',
      },
      isSubmit:false,
      showProgress:false,
      lastDialog:false,
      notPassDialog:false,
      textarea:'',
      feedbackInfo:{},
      temporary:{
          auditText:'',
          picList:[],
      },
      permanentSolution:{
          auditText:'',
          picList:[],
      },
      wayBill:{},
      dialogBig:false,
      bigImg:'',
      detail:{},
      lastId:'',
      header:{satoken:sessionStorage.getItem('satoken'),},
      action:baseURL2+'/manage/car/feedback/upload/file/customer'
    };
  },
  mounted(){
      this.feedbackInfo = getSession('feedBackData')
      this.fileData.customerId = getSession('person').customerId
      if(this.feedbackInfo.displayStatus!=4){
          this.getDetail()
      }else{
          this.showProgress = true
      }
      
      //  displayStatus ,0工厂审批中、1待处理、2工厂处理中、3已结束,-1表示状态错误
  },
  methods:{
      beforeFileUpload(file){
          this.uploading = true
          let lang = ''
          let language = sessionStorage.getItem('lang')
          language=='zh'?lang=0:language=='en'?lang=1:language=='ru'?lang=2:lang=3
          this.header.lang = lang
          let total = 0
          total = this.sum+(file.size/1024/1024)
          // console.log(total)
          if(total>=this.max){
            this.$DonMessage.warning(this.$t('home.fileSum'))
            this.uploading = false
            return false
          }
          const imgLt = 10;
          let limit =0
          let isLt = 0
          // 图片 
          const isJPG = file.type === 'image/jpeg'
          const isPNG = file.type === 'image/png'
          const isSvg = file.type === 'image/svg+xml'
          let isImg = false
          if (isJPG || isPNG || isSvg){
             isImg = true
          }else{
              this.$DonMessage.warning(this.$t('zlfk.zctp'))
              this.uploading = false
              return false
          }
          if( isImg){
            limit = imgLt
            isLt= file.size / 1024 / 1024 < limit;
            if (!isLt) {
              this.uploading = false
              this.$DonMessage.warning(this.$t('home.img10M'));
            }
              return  isImg && isLt;
          }



          
      
     
      

      },
      handleChange(file,fileList){
        this.upLoadFiles = fileList

      },
      handleSuccessFile(res,file){
          
          if(res.status==0){
              this.fileList.push({
                  ...res.data,
                  url:res.data.filePath,
                  name:res.data.fileName
              })
              if(this.upLoadFiles.length==this.fileList.length){
                this.uploading = false
              }
          }else{
            this.$DonMessage.warning(res.message)
              let uid = file.uid // 关键作用代码，去除文件列表失败文件
              let idx = this.$refs.uploadFile.uploadFiles.findIndex(item => item.uid === uid) 
              this.$refs.uploadFile.uploadFiles.splice(idx, 1)
              if(this.upLoadFiles.length==this.fileList.length){
                this.uploading = false
              }
          }
      },
      async handleFinished(){
          this.lastDialog = false
          let query = {
              data:{
                  carQualityFeedbackNotifyId:this.lastId
              }
          }
          const res = await knowWaybill(query)
          if(res.status==0){
              this.getDetail()
          }
      },
      handleBigImg(data){
          this.bigImg = data
          this.dialogBig = true
      },
      async getDetail(){
          let query = {
              data:{
                  carQualityFeedbackId:this.feedbackInfo.carQualityFeedbackId
              }
          }
          const res = await feedBackDetail(query)
          if(res.status==0){
              this.showProgress = true
              this.detail = res.data
              if(res.data.temporaryMeasure!==null){
                  this.temporary = res.data.temporaryMeasure
              }
              if(res.data.permanentSolution!==null){
                  this.permanentSolution = res.data.permanentSolution
                 
              }
              this.wayBill = res.data.waybillInfo

              if(res.data.unknownNotify.length>0){
                  res.data.unknownNotify.map(item=>{
                      if(item.userTaskId =='Activity_0kf65a0'){
                          this.wayBill.isKonw=false
                          this.wayBill.konwId = item.carQualityFeedbackNotifyId
                      }
                      if(item.userTaskId=='Activity_1hqoizd'){
                          this.lastDialog = true
                          this.lastId = item.carQualityFeedbackNotifyId

                      }
                  })
              }else{
                  this.wayBill.isKonw=true
              }
              
              
              
              


          }
      },
      async handlePass(type){
          this.isSubmit = true
          let query = {
              data:{
                  approval: type,
                  carQualityFeedbackId: this.feedbackInfo.carQualityFeedbackId,
                  rejectionReason: type==0?this.textarea='':this.textarea = this.textarea,
                  files: [...this.fileList]
              }
          }
          
          const res = await isPass(query)
          if(res.status==0){
              this.isSubmit = false
              this.$router.go(-1)
          }else{
            this.$DonMessage.warning(res.message)
              this.isSubmit = false
          }
      },
      back(){
          this.$router.go(-1)
      },
      toBack(){
          
          
          this.$router.push({name:'backInfo',query:{
              vin:this.feedbackInfo.vin
          }})
          setSession('feedBackWaybill',this.wayBill)

      },
      handleRemove(file, fileList) {
       this.uploading = false
        let uid = file.response.data.uploadFileId
          this.fileList.forEach((pic,i)=>{
              if(pic.uploadFileId==uid){
                  this.fileList.splice(i, 1)
              }
        
      })
      },
      
      beforeRemove(file, fileList) {
        return this.$confirm(`确定移除 ${ file.name }？`);
      },
      confitmWay(){},
      
  }
}
</script>
<style lang="scss" scoped>
.zl-detail{
  padding-left: 30px;
  margin-top: 30px;
  .img-content{
      width: 600px;
      flex-wrap: wrap;
  }
  .img-content2{
      width: 490px;
      flex-wrap: wrap;
  }
  .big-img{
      width: 460px;
      img{
          width: 100%;
      }
  }
  ::v-deep ::v-deep .el-textarea.is-disabled .el-textarea__inner{
    min-width: 400px!important;
  }
  .d-title{
      font-size: 16px;
      font-weight: bold;
      line-height: 40px;
  }
  .basic{
      max-width: 600px;
  }
  .back-btn{
      position: fixed;
      right: 100px;
      bottom: 40px;
  }
  .process{
      flex-direction: column;
  }
  .prcs-item{
      flex-direction: column;
  }
  .p-content{
      margin: 10px 0;
      .status-txt{
          font-size: 14px;
          color: #bfbfbf;
      }
      .way{
          margin-left: 20px;
          .img-box{
              margin-left: 10px;
              .img{
                  // width: 80px;
                  // height: 80px;
                  width: 100%;
                      height: 100%;
                  background: #eee;
                  margin-right: 10px;
                  overflow: hidden;
                  img{
                      width: 100%;
                      height: 100%;
                      object-fit: cover;
                  }
              }
          }
          
      }
  }
  .text{
  
              p{
                  border: 1px solid #c0c4cc;
                  background: #eee;
                  padding: 4px;
                  border-radius: 2px;
                  font-size: 12px;
                  line-height: 20px;
                  max-width: 200px;
              }

          }
  .p-line{
      width: 40px;
      img{
          width: 100%;
      }
  }
  .active{
      color:#409EFF!important;
  }
  .img-box{
      margin-right: 10px;
      width: 88px;
      height: 88px;
      border: 1px dashed #b0adad;
      overflow: hidden;
      border-radius: 5px;
      box-sizing: border-box;
      position: relative;
      margin-bottom: 6px;
      img{
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        object-fit: cover;
        // position: absolute;
      }
      .zzc{
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        background: rgba($color: #000000, $alpha: .6);
        text-align: center;
        line-height: 88px;
        display: none;
        i{
          font-size: 26px;
          color: #fff;
          cursor: pointer;
        }
      }
    }
    .img-box:hover{
      .zzc{
        display: block;
      }
    }
}
.reject-box{
  .reject-title{
      color: red;
      line-height: 40px;
      font-size: 16px;
  }
  .text{
      span{
          font-size: 14px;
          color: #333;
          margin-right: 20px;
      }
  }
}
.retime{
    margin-left: 20px;
    display:inline-block; 
    font-size: 12px;
    color: #a9a5a5;
}
</style>